import { Component, app, ojs } from "modular-openscriptjs";
import { dom, tool } from "../../fotastart";
import { eParse, cleanDispose } from "../../helpers";
import { dc } from "../../declarations";
import { $e } from "../../ojs.events";
import FormField from "../Blocks/FormField";

const h = app("h");
const broker = app("broker");

ojs(FormField);

export default class DepositCapaForm extends Component {
	renderForm(...args) {
		return h.div(
			h.FormField({
				type: "number",
				id: "capa-deposit-price",
				oninput: this.method("toCapa", "${this}"),
				label: { value: `Price (${dc.userCurrency})` },
				helpText: { value: `Amount you want to pay` },
				dependencies: ["dcf-capa-deposit-amount"],
				data_ff_dependency_hook: "dcf-capa-deposit-price",
			}),
			h.FormField({
				type: "number",
				id: "capa-deposit-amount",
				oninput: this.method("toCost", "${this}"),
				label: { value: `Amount (${dc.capaSymbol})` },
				helpText: { value: `Amount of capa to deposit` },
				dependencies: ["dcf-capa-deposit-price"],
				data_ff_dependency_hook: "dcf-capa-deposit-amount"
			}),
			...args
		);
	}

	toCapa(elem) {
		let input = dom.id("capa-deposit-amount");
		if (!input) return;
		input.value =
			elem.value == ""
				? ""
				: Math.floor(
					elem.value /
					(window?.systemConfigs?.capaExchangeRate ?? 0.01),
				);
		input.dispatchEvent(new CustomEvent("ff-dependency-update"));
	}

	toCost(elem) {
		let input = dom.id("capa-deposit-price");
		if (!input) return;
		input.value =
			elem.value == ""
				? ""
				: Math.ceil(
					elem.value *
					(window?.systemConfigs?.capaExchangeRate ?? 0.01),
				);
		input.dispatchEvent(new CustomEvent("ff-dependency-update"));
	}

	$$capa = {
		deposited: (ed, event) => {
			this.closeForm();
		},

		is: {
			depositing: (ed, event) => {
				this.closeForm();
			},
		},

		needs: {
			depositForm: (ed, event) => this.showForm(ed, event),
		},

		has: {
			depositError: (ed, event) => {
				let data = eParse(ed);
				const btn = dom.id(data.meta.buttons.right);

				dom.enable(btn);
				dom.put("Deposit", btn);
			},
		},
	};

	holder = null;

	closeForm() {
		if (this.holder) {
			this.holder.hide();
		}
	}

	submitDeposit() {
		const btn = dom.id("capa-deposit-submit-btn");
		if (btn) {
			dom.disable(btn);
			dom.put("...", btn);
		}

		broker.send(
			$e.capa.needs.purchase,
			payload(
				{
					amount: dom.id("capa-deposit-price")?.value ?? 0,
				},
				{
					buttons: {
						right: "capa-deposit-submit-btn",
					},
				},
			),
		);
	}

	renderFooter() {
		return h.div(
			{ class: "d-flex gap-3 w-100 mt-2" },
			h.button(
				{
					class: "btn btn-light rounded-pill px-4 py-3 fw-bold flex-fill border-0",
					style: "background: #f1f5f9; color: #475569;",
					onclick: this.method("closeForm"),
				},
				"Cancel"
			),
			h.button(
				{
					id: "capa-deposit-submit-btn",
					class: "btn btn-success rounded-pill px-4 py-3 fw-bold flex-fill border-0 shadow-sm",
					onclick: this.method("submitDeposit"),
				},
				"Deposit"
			)
		);
	}

	async showForm(ed, event) {
		if (this.holder) {
			cleanDispose(this.holder);
		}

		let options = { backdrop: "static" };

		this.holder = tool.plainModal(
			h.DepositCapaModal(
				this.renderForm(),
				this.renderFooter()
			),
			options
		);

		this.holder.show();
	}
}

export function DepositCapaModal(bodyContent, footerContent) {
	return h.$(
		h.div(
			{ class: "modal-content border-0 shadow-lg", style: "border-radius: 24px;" },
			h.div(
				{ class: "modal-body p-4" },
				bodyContent,
				h.div(
					{ class: "modal-footer border-0 p-0 pt-3" },
					footerContent,
				),
			),
		),
	);
}

ojs(DepositCapaForm, DepositCapaModal);